import * as yup from 'yup';

export const confirmationCodeFormSchema = yup.object().shape({
    confirmationCode: yup
        .string()
        .min(6, '')
        .max(6, '')
        .required('El código es requerido para continuar.')
});